<!--  -->
<template>
  <div class="header_wrap">
    <div class="header main_w">
      <div class="logo">
        <img :src="curIdx == 0 ? logoData.homeImg : logoData.img" alt="" />
      </div>
      <div class="nav">
        <div
          v-for="(item, i) in titleData"
          :key="i"
          :class="curIdx == i ? 'active' : ''"
          @click="navClick(i)"
        >
          {{ item.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  name: "ztbHeader",
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      logoData: {
          homeImg: require("../../assets/images/home_logo.png"),
          img: require("../../assets/images/logo.png"),
      },
      titleData: [
        {
          title: "首页",
          idx: 0,
        },
        {
          title: "校方后台登录",
          idx: 1,
        },
        {
          title: "我的录播课程",
          idx: 2,
        },
        {
          title: "公开课课件",
          idx: 3,
        },
        {
          title: "关于我们",
          idx: 4,
        },
      ],
      curIdx: 3,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    navClick(idx) {
      let _this = this;
      _this.curIdx = idx;
      switch(idx){
        case 0:
          window.location.href=_this.$url+"/pages/index.html";
          break;
        case 1:
          window.location.href=_this.$url+"/pages/page/login_school.html";
          break;
          case 2:
          window.location.href=_this.$url+"/pages/page/login_taped.html";  
          break;
          case 4:
          window.location.href=_this.$url+"/pages/page/about.html#/history"
          break;

      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style  lang='less'>
//@import url(); 引入公共css类
.header_wrap {
  .header {
    height: 90px;
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    align-items: center;
    // align-items: center;
    .logo {
      width: 134px;
      height: 50px;
      img {
        height: 100%;
      }
    }
    .nav {
      width:80%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      div {
        color: #4a4a4a;
        cursor: pointer;
        font-size: 18px;
        height: 36px;
        line-height: 36px;
        padding: 5px 10px;
        border-radius: 6px;

      }
      div.active {
        color: #ffffff !important;
        background: #7dd6ff !important;
      }
    }
  }
}
</style>